import DefaultButton from './DefaultButton';
import Tooltip from '@mui/material/Tooltip';

function TooltipButton({icon, iconSize, iconColor, warning, primary, text, link, onClick, tooltip, children }) {
  
  return (
	  <Tooltip title={tooltip}>
	     <div>
		 <DefaultButton icon={icon} iconSize={iconSize} iconColor={iconColor} warning={warning} primary={primary} text={text} link={link} onClick={onClick}>
		    {children}
		 </DefaultButton>
		 </div>
	  </Tooltip>
   )
}

export default TooltipButton;
